import Edit from '@mui/icons-material/Edit';
import { DetailedList, DetailedListType } from '@qbe/ads-blocks-forms';
import { IconButton } from '@qbe/ads-core';
import * as React from 'react';
import { useState } from 'react';

import EditModal from './EditModal';

export type ListType = {
  [key: string]: DetailedListType;
};

type ReviewListProps = {
  title: string;
  list: ListType;
  editRoute?: string;
};

const ReviewList: React.FC<ReviewListProps> = ({ title, list, editRoute }) => {
  const [showModal, setShowModal] = useState(false);

  const listWithoutSameValueAsLabel = Object.values(list).map((item) => ({
    ...item,
    value: item?.value === item?.label ? '' : item?.value,
  }));

  return (
    <>
      <DetailedList
        variant="multiple"
        sx={{ padding: 0, overflowWrap: 'break-word' }}
        title={title}
        list={listWithoutSameValueAsLabel}
        titleComponents={
          editRoute ? (
            <IconButton
              data-track={`Click here to edit - ${title}`}
              iconProps={{
                muiIcon: Edit,
                color: 'primary',
                label: 'Edit',
              }}
              onClick={() => setShowModal(true)}
            />
          ) : null
        }
      />
      {editRoute && showModal && (
        <EditModal closeModal={() => setShowModal(false)} editRoute={editRoute} />
      )}
    </>
  );
};

export default ReviewList;
